import img2 from './Images/img2.png'
import R_Logo from './Images/R_Logo.png'
import { Link } from 'react-router-dom';
import './App.css'
import { variableName } from './variableName';
import { NavLink, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useState } from 'react';


export default function Header() {

    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const isReportsActive = location.pathname.startsWith("/reports");


    return (
        <>
            <nav className="top-nav">

                <Link to="/" className="nav-left">
                    <img src={img2} className="newLogo" alt="Logo" />
                    <h2 className="brand-name" style={{ textDecoration: "none" }}>{variableName.outerHeaderName}</h2>
                </Link>

                {/* HAMBURGER (mobile) */}
                <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                    ☰
                </div>

                <ul className={`nav-center ${menuOpen ? "open" : ""}`}>
                    <li>
                        <NavLink
                            to="/ProductList" className="nav-link"
                            style={{ textDecoration: "none" }}
                        >
                            <li  >Company List</li>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink className="nav-link" to="/New_Product/" style={{ textDecoration: "none" }}>
                            <li className=" ">New Products</li>
                        </NavLink>
                    </li>

                    <li>
                        <NavLink className="nav-link" to="/ContactUs/" style={{ textDecoration: "none" }}>
                            <li className=" ">Contact Us</li>
                        </NavLink>
                    </li>


                </ul>

                <div className="nav-right">

                    {/* <img src={R_Logo} height={100} width={100} className="R" alt="" /> */}

                </div>

            </nav>




            {/* <div className="product_header">
                <Link to='/'><img src={img2} height={100} width={100} id="S" alt="" style={{ marginTop: "5px" }} /></Link>
                <img src={R_Logo} height={100} width={100} className="R" alt="" />
            </div>
            <div className='lists'>
                <Link to="/ProductList" style={{ textDecoration: "none", marginLeft: "30px" }}><li>Company List</li></Link>
                <Link to="/New_Product" style={{ textDecoration: "none" }}><li>New Products</li></Link>
            </div> */}

        </>
    )
}